module.exports = __webpack_public_path__ + "static/media/successImage.d2e34561.png";